import React from 'react';
import { Shield, Sun, Gamepad2, GraduationCap } from 'lucide-react';
import { IMAGES } from '../utils/constants';

const Facilities = () => {
    const facilities = [
        {
            title: "Safe Outdoor Play Area",
            desc: "Spacious and secure playground with soft turf and age-appropriate equipment to ensure safety while playing.",
            img: IMAGES.facilityOutdoor,
            icon: <Shield size={24} color="var(--color-success)" />
        },
        {
            title: "Colorful Classrooms",
            desc: "Vibrant, stimulating environments designed to spark curiosity and creativity in young minds.",
            img: IMAGES.facilityClassroom,
            icon: <Sun size={24} color="var(--color-secondary-dark)" />
        },
        {
            title: "Indoor Play Spaces",
            desc: "Climate-controlled indoor areas for physical activities, ensuring fun continues regardless of the weather.",
            img: IMAGES.facilityIndoor,
            icon: <Gamepad2 size={24} color="var(--color-primary)" />
        },
        {
            title: "Interactive Learning Tools",
            desc: "Modern educational toys and multimedia tools to enhance the learning experience.",
            img: IMAGES.facilityLearning,
            icon: <GraduationCap size={24} color="var(--color-accent-dark)" />
        }
    ];

    return (
        <div className="page-wrapper">
            <div className="page-header">
                <div className="container text-center">
                    <h1 className="page-title">Facilities</h1>
                    <p className="page-subtitle">World-class infrastructure for your child's safety and comfort.</p>
                </div>
            </div>

            <div className="container section">
                <div className="facilities-grid">
                    {facilities.map((fac, i) => (
                        <div key={i} className={`facility-row ${i % 2 === 1 ? 'reverse' : ''}`}>
                            <div className="facility-img-wrapper">
                                <img src={fac.img} alt={fac.title} className="facility-img" />
                            </div>
                            <div className="facility-content">
                                <div className="facility-icon-box">
                                    {fac.icon}
                                </div>
                                <h2 className="facility-title">{fac.title}</h2>
                                <p className="facility-desc">{fac.desc}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            <style>{`
        .page-header {
           background-color: var(--color-accent-dark);
        }

        .facilities-grid {
          display: flex;
          flex-direction: column;
          gap: 6rem;
        }

        .facility-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 4rem;
          align-items: center;
        }

        .facility-row.reverse {
          direction: rtl; /* Flip the order visually */
        }
        
        .facility-row.reverse .facility-content {
          direction: ltr; /* Reset text direction */
        }

        .facility-img-wrapper {
          position: relative;
        }

        .facility-img {
          width: 100%;
          border-radius: 2rem;
          box-shadow: var(--shadow-lg);
          transition: transform 0.3s;
        }
        
        .facility-row:hover .facility-img {
          transform: scale(1.02);
        }

        .facility-content {
          padding: 1rem;
        }

        .facility-icon-box {
          width: 60px;
          height: 60px;
          background: white;
          border-radius: 1rem;
          box-shadow: var(--shadow-md);
          display: flex;
          align-items: center;
          justify-content: center;
          margin-bottom: 1.5rem;
        }

        .facility-title {
          font-size: 2rem;
          font-weight: 700;
          margin-bottom: 1rem;
          color: var(--color-text-main);
        }

        .facility-desc {
          font-size: 1.125rem;
          color: var(--color-text-light);
          line-height: 1.7;
        }

        @media (max-width: 960px) {
          .facility-row {
            grid-template-columns: 1fr;
            text-align: center;
            gap: 2rem;
          }
          
          .facility-row.reverse {
            direction: ltr;
          }

          .facility-content {
             display: flex;
             flex-direction: column;
             align-items: center;
          }

          .facility-img-wrapper {
             order: -1; 
          }
          
          .facilities-grid {
             gap: 4rem;
          }
        }
      `}</style>
        </div>
    );
};

export default Facilities;
